export const COUNTRIES_PATH = '/countries-dashboard'
